module.exports = __webpack_public_path__ + "static/front/img/hospital-cleaning.c612a87b.jpg";